import { initialItemData, rarities, textSizes, titleNameSizes, types } from './constants';

export default {
  generatedItems: {},
  item: { ...initialItemData },
  rarities,
  timeoutId: null,
  textSizes,
  titleNameSizes,
  types
}